// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"styles_spinnerContainer__3Vir0"};